// §5.4 — house window semantics: the plainest of the three. Halves and full, a maximize button
// that maximizes, no snap assist.
import type { SnapLayout, SnapZone, WindowManagerPolicy } from '@hangar/shared';

// §5.4's fraction→pixel conversion lives in `kernel/wm/geometry` because the snap engine needs
// it and may not import a skin (§6.5). Re-exported so this skin's own callers read naturally.
export { zoneRect } from '@/kernel/wm/geometry';

/** Zone rects are fractions of the work area, 0..1 (§5.4). */
export const HOUSE_LAYOUTS: readonly SnapLayout[] = [
  {
    id: 'halves',
    label: 'Halves',
    zones: [
      { id: 'left', rect: { x: 0, y: 0, w: 0.5, h: 1 } },
      { id: 'right', rect: { x: 0.5, y: 0, w: 0.5, h: 1 } },
    ],
  },
  {
    id: 'full',
    label: 'Full',
    zones: [{ id: 'full', rect: { x: 0, y: 0, w: 1, h: 1 } }],
  },
];

function zone(id: string): SnapZone | null {
  for (const layout of HOUSE_LAYOUTS) {
    const found = layout.zones.find((z) => z.id === id);
    if (found) return found;
  }
  return null;
}

export const housePolicy: WindowManagerPolicy = {
  onMaximizeButton: () => 'maximize',

  onEdgeDrag(edge) {
    switch (edge) {
      // The house skin has no quadrants (that is the windows11 column), so a corner folds onto
      // the half it is nearest — otherwise the top-left of the screen is a dead zone.
      case 'left':
      case 'topLeft':
      case 'bottomLeft':
        return zone('left');
      case 'right':
      case 'topRight':
      case 'bottomRight':
        return zone('right');
      case 'top':
        return zone('full');
      default:
        return null;
    }
  },

  snapZones: () => HOUSE_LAYOUTS.map((layout) => ({ ...layout, zones: [...layout.zones] })),

  switcherModel: () => 'windows',
  minimizeTarget: () => 'barSlot',
  chromeSide: () => 'right',
  snapAssist: () => false,
};
